import { useTranslation } from "react-i18next";
import { usageLog } from "../features/api/dts_api_wrapper";
import { useErrorDialog } from "./index";

export type UsageLogProps = {
  userId: string;
  displayPage: string;
  displayDateTime: string;
};

// 画面初期表示時の利用ログ登録
export const useInitUsageLog = (
  { userId, displayPage, displayDateTime }: UsageLogProps,
  notCloseTab: boolean = true //タブを閉じるかどうか(デフォルト値：タブを閉じない)
) => {
  //言語切替用
  const { t } = useTranslation();
  const { showErrorDialog } = useErrorDialog();
  let isErrorDialog = false; //関数内でエラーダイアログを表示したかどうか

  const handleInit = async () => {
    try {
      if (!userId) {
        //何らかの理由でuserIdが読み込めなかった
        throw new Error("userId is unknown");
      }
      //利用ログ登録
      const usageLogResult = await usageLog(
        userId,
        displayPage,
        displayDateTime
      );

      //　現在は利用ログでエラーが出てもコンソール出力のみ
      if ("errorMessage" in usageLogResult) {
        console.log("errorMessage: ", usageLogResult.errorMessage);
      }
      return isErrorDialog;
    } catch (err) {
      console.log(`[${displayPage}]err: ${err}`);
      if (notCloseTab) {
        if (
          err instanceof Error &&
          (err.message === "Expired token" || err.message === "Invalid token")
        ) {
          //LocalStorageのセッション情報クリア
          const userpool_client_id =
            process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID ?? "";
          localStorage.removeItem(
            `CognitoIdentityServiceProvider.${userpool_client_id}.accessToken`
          );
          localStorage.removeItem(
            `CognitoIdentityServiceProvider.${userpool_client_id}.refreshToken`
          );
          localStorage.removeItem(
            `CognitoIdentityServiceProvider.${userpool_client_id}.idToken`
          );
          localStorage.removeItem(
            `CognitoIdentityServiceProvider.${userpool_client_id}.clockDrift`
          );
          localStorage.removeItem(
            `CognitoIdentityServiceProvider.${userpool_client_id}.LastAuthUser`
          );

          showErrorDialog(
            t("共通エラーポップ.エラー"),
            t("共通エラーポップ.セッションがタイムアウトしました。"),
            "ydsyos"
          ); //エラー", "セッションがタイムアウトしました。(YDS/YOSに遷移する)
        } else {
          showErrorDialog(
            t("共通エラーポップ.エラー"),
            t("共通エラーポップ.通信エラーが発生しました。"),
            "navigateToTopPage"
          ); //エラー", "通信エラーが発生しました。(トップページに遷移する)
        }
      } else {
        // HowToFix画面など
        showErrorDialog(
          t("共通エラーポップ.エラー"),
          t("共通エラーポップ.通信エラーが発生しました。"),
          "closeTab"
        ); // エラー", "通信エラーが発生しました。(タブを閉じる)
      }
      isErrorDialog = true;
      return isErrorDialog;
    }
  };

  return {
    handleInit,
  };
};
